export default "__VITE_ASSET__CS8ULk2d__"